import { createRouter, createWebHistory } from 'vue-router'
import store from '@/store'
import redirectToLogin from '@/router/redirect-to-login'
import redirectBasedOnRole from '@/router/redirect-based-on-role'
import PageNotFound from '@/views/PageNotFound.vue'
import onboardingRoutes from './routes/onboarding'
import appRoutes from './routes/app'
import guestRoutes from './routes/guest'

const router = createRouter({
    history: createWebHistory(),
    routes: [
        {
            // handles no path (typically after login)
            // a route must have either a component or redirect property
            // redirects ignore beforeEnter guard
            // redirects must be sync
            path: '',
            redirect(to) {
                return redirectBasedOnRole()
            },
        },
        {
            // handles logout from redirectBasedOnRole
            path: '/logout',
            name: 'logout',
            beforeEnter: async (to, from, next) => {
                await redirectToLogin(from, next)
            },
        },
        ...guestRoutes,
        ...onboardingRoutes,
        ...appRoutes,
        {
            path: '/404',
            name: '404',
            component: PageNotFound,
            beforeEnter: (to, from, next) => {
                if (!store.getters.auth) {
                    next('/login')
                } else {
                    next()
                }
            },
        },
        {
            path: '/:pathMatch(.*)*',
            redirect: '/404',
        },
    ],
})

router.afterEach((_, from) => {
    store.dispatch('history/updateLastPage', from)
})

export default router
